import React, { useEffect, useState } from 'react';

import { IconPicture } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import styles from './CatalogThumb.module.scss';

interface CatalogThumbProps {
    src?: string | null;
    large?: boolean;
}

export function CatalogThumb({ src, large }: CatalogThumbProps) {
    const [broken, setBroken] = useState(false);

    useEffect(() => setBroken(false), [src]);

    return (
        <span className={cx(styles.thumb, large && styles.thumbLg)}>
            {src && !broken ? (
                <img
                    src={src}
                    alt=""
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    onError={() => setBroken(true)}
                />
            ) : (
                <IconPicture />
            )}
        </span>
    );
}